import {
  PriceSectionEditable,
  ProductCard,
} from '@airship-platform/airship-proposal';
import { BaseDialog, FlexBox } from '@airship-platform/jam-web/components';
import Typography from '@mui/material/Typography';
import { AppointmentProposalOptionProduct } from '../../../data-access/appointmentProposalOptionProducts';

interface RemoveProductModalProps {
  product: AppointmentProposalOptionProduct;
  isModalOpen: boolean;
  isLoading: boolean;
  onModalClose: () => void;
  onProductRemove: () => void;
}

const RemoveProductModal: React.FC<RemoveProductModalProps> = ({
  product,
  isModalOpen,
  isLoading,
  onModalClose,
  onProductRemove,
}) => (
  <BaseDialog
    fullWidth={false}
    open={isModalOpen}
    onClose={onModalClose}
    title={'Remove product'}
    footerAction={{
      left: {
        children: 'Cancel',
        onClick: () => onModalClose(),
        color: 'softGold',
      },
      right: {
        children: 'Confirm and remove product',
        onClick: () => onProductRemove(),
        disabled: isLoading,
      },
    }}
  >
    <FlexBox
      alignItems={'center'}
      flexDirection={'column'}
      justifyContent={'center'}
      gap={4}
    >
      <Typography variant={'body2'}>
        Confirm you want to remove the following product.
      </Typography>
      {product && (
        <ProductCard
          product={product}
          priceSection={
            <PriceSectionEditable
              defaultPriceType={'STANDARD'}
              prices={[
                {
                  value: product.price,
                  currency: product.currency,
                  priceType: 'STANDARD',
                  taxable: product.taxable,
                },
              ]}
            />
          }
        />
      )}
    </FlexBox>
  </BaseDialog>
);

export default RemoveProductModal;
